import capitalize from 'lodash/capitalize';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import React, { useContext, useState } from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import Context from '../service/Context';
import InfoModal from '../../../utils/components/InfoModal';
import themeStyles from '../PaymentDetailsComponent.styles';
import { PaymentFrequency, PaymentMethod } from '../../../core/reducers/financialCalculators';
import { useInventoryTrimCardContext } from '../../TrimCardGrid/TrimCard/InventoryTrimCardProvider';
import { useLanguage } from '../../../utils/sitecoreContext';
const PaymentAmountContainer = themeStyles.apply(Box, 'PaymentAmountContainer');
const PaymentLabelCopy = themeStyles.apply(Copy, 'PaymentLabelCopy');
const PaymentContentCopy = themeStyles.apply(Copy, 'PaymentContentCopy');
const Finance = () => {
    var _a;
    const { t } = useTranslation();
    const language = useLanguage();
    const { paymentLabel, paymentAmount, paymentTooltipParams } = useContext(Context);
    const { excludePaymentTooltipPrefix } = (_a = useInventoryTrimCardContext()) !== null && _a !== void 0 ? _a : {};
    const paymentLabelContent = t(`Shared.Common.${paymentLabel.frequency}${capitalize(paymentLabel.method)}Label`);
    const paymentFrequencyLabel = paymentLabel.frequency === PaymentFrequency.biweekly ? 'biWeekly' : paymentLabel.frequency;
    const getTooltipLabel = (sharedCommonKey) => {
        const prefix = excludePaymentTooltipPrefix ? '' : `${t('Shared.Common.prePaymentTooltipLabel')} `;
        return `${prefix}${t(`Shared.Common.${sharedCommonKey}`, {
            ...paymentTooltipParams,
            paymentFrequency: t(`Shared.Common.PaymentFrequency.${paymentFrequencyLabel}`),
        })}`;
    };
    const [showInfoModal, setShowInfoModal] = useState(false);
    const currentPaymentTooltip = paymentLabel.method === PaymentMethod.lease
        ? getTooltipLabel('paymentTooltipLabel')
        : getTooltipLabel('paymentTooltipFinanceLabel');
    return (React.createElement(React.Fragment, null,
        React.createElement(PaymentAmountContainer, null,
            React.createElement(PaymentLabelCopy, { size: "extraSmall", "data-testid": "cy-payment-frequency-label" }, paymentLabelContent)),
        React.createElement(PaymentContentCopy, { size: "regular", "data-testid": "cy-payment-frequency-value" },
            formatPrice(paymentAmount, language, 2),
            React.createElement(InfoModal, { showModal: showInfoModal, setShowModal: setShowInfoModal, content: currentPaymentTooltip, isDark: false, "data-testid": "cy-payment-tooltip", display: "inline-block" }))));
};
export default Finance;
